{
  "gnin.fps-redirect.changeboarding.description": [
    {
      "type": 0,
      "value": "Looking for more? Switch to find results and answers from all your Atlassian and connected apps."
    }
  ],
  "gnin.fps-redirect.changeboarding.primary-button": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "gnin.fps-redirect.changeboarding.title": [
    {
      "type": 0,
      "value": "Switch to search beyond Jira"
    }
  ],
  "post-office.quick-find-spotlight.spotlight-body-1": [
    {
      "type": 0,
      "value": "Apply a mix of filters to narrow down results."
    }
  ],
  "post-office.quick-find-spotlight.spotlight-body-2": [
    {
      "type": 0,
      "value": "Search only Jira, or expand across all your Atlassian and connected apps."
    }
  ],
  "post-office.quick-find-spotlight.spotlight-button-done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "post-office.quick-find-spotlight.spotlight-button-next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "post-office.quick-find-spotlight.spotlight-heading-1": [
    {
      "type": 0,
      "value": "Filter for what you need"
    }
  ],
  "post-office.quick-find-spotlight.spotlight-heading-2": [
    {
      "type": 0,
      "value": "Choose where to search"
    }
  ],
  "search-page.gnin-redirect.changeboarding.back-button": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "search-page.gnin-redirect.changeboarding.next-button": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "search-page.gnin-redirect.changeboarding.primary-button": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "search-page.gnin-redirect.changeboarding.step-label": [
    {
      "type": 1,
      "value": "current"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    }
  ],
  "search-page.gnin-redirect.changeboarding.step1.description": [
    {
      "type": 0,
      "value": "Your results may come from all your apps or just Jira, depending on your search terms."
    }
  ],
  "search-page.gnin-redirect.changeboarding.step1.image-alt": [
    {
      "type": 0,
      "value": "Rovo full page search smart AI answer illustration"
    }
  ],
  "search-page.gnin-redirect.changeboarding.step1.title": [
    {
      "type": 0,
      "value": "Search that adapts to you"
    }
  ],
  "search-page.gnin-redirect.changeboarding.step2.description": [
    {
      "type": 0,
      "value": "You can switch anytime to search Jira work items (including JQL)."
    }
  ],
  "search-page.gnin-redirect.changeboarding.step2.image-alt": [
    {
      "type": 0,
      "value": "Rovo full page search illustration"
    }
  ],
  "search-page.gnin-redirect.changeboarding.step2.title": [
    {
      "type": 0,
      "value": "Switch your view anytime"
    }
  ],
  "search-plex.jira-quick-find-intent-detection-changeboarding.description.no-translate": [
    {
      "type": 0,
      "value": "Quick find intent detection test message."
    }
  ],
  "search-plex.jira-quick-find-intent-detection-changeboarding.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ]
}